import { render } from "./BrowseArticles.vue?vue&type=template&id=4187b6f3&scoped=true&ts=true"
import script from "./BrowseArticles.ts?vue&type=script&lang=ts"
export * from "./BrowseArticles.ts?vue&type=script&lang=ts"

import "./BrowseArticles.vue?vue&type=style&index=0&id=4187b6f3&scoped=true&lang=scss"

import exportComponent from "D:\\ColorMetal\\cmportal-frontend-master\\cmportal-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4187b6f3"]])

export default __exports__
import QImg from 'quasar/src/components/img/QImg.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QCircularProgress from 'quasar/src/components/circular-progress/QCircularProgress.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QBar from 'quasar/src/components/bar/QBar.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QSpinnerGears from 'quasar/src/components/spinner/QSpinnerGears.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QImg,QBtn,QIcon,QTooltip,QToggle,QInput,QCheckbox,QCircularProgress,QDialog,QCard,QBar,QSpace,QCardSection,QScrollArea,QSpinnerGears});qInstall(script, 'directives', {ClosePopup});
